import { render } from "./CardDetail.vue?vue&type=template&id=17a3df9b&scoped=true"
import script from "./CardDetail.js?vue&type=script&lang=js&external"
export * from "./CardDetail.js?vue&type=script&lang=js&external"

import "./CardDetail.scss?vue&type=style&index=0&id=17a3df9b&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a3df9b"]])

export default __exports__